// src/pages/Modals/AddSubject.js
import React from "react";
import SubjectFormModal from "../../SchoolDashApp/Class/Subjects/SubjectFormModal";
import { Box } from "@mui/material";

const AddSubject = ({ open, handleClose }) => {
  const refreshSubjectList = () => console.log("Subject list refreshed!");
  return (
    <Box>
      <SubjectFormModal open={open} handleClose={handleClose} onSubjectCreated={refreshSubjectList} />
    </Box>
  );
};

export default AddSubject;
